import { getActiveSubscription } from '@/data/session/session-globals';

export const PENDO_INTERNAL_SUBSCRIPTION_NAME = 'pendo-internal';

// The pendo-internal subscription defaults the replay library to "Today"; every
// other subscription keeps the 7-day window. Gating on the subscription name
// (rather than the environment) keeps the behavior testable across all envs.
export function usesTodayReplayLibraryDefault () {
    return getActiveSubscription()?.name === PENDO_INTERNAL_SUBSCRIPTION_NAME;
}
